import {
    ProductListSuggestionStyles,
    suggestionStyles,
} from "@insite/content-library/Widgets/ProductList/ProductListSuggestion";
import { css } from "styled-components";

suggestionStyles.wrapper = {
    css: css`
        margin-top: 30px;
        padding-left: 12px;
    `,
};
